(function($) {

    $.fn.sleeveeditor = function (options) {

        var $elem = this;
        var settings = $.extend({
            poll_timeout: 2000
        }, options);

        var type = settings.type;
        var record_id = settings.record_id;
        var template_id = settings.template_id;
        var preview = (settings.is_rendered) ? $('.cover-editor-preview > img').attr('src') : null;

        if(preview) {
            enableFinish();
        } else {
            enablePreview();
        }

        if(type == 'back' && !settings.is_rendered) {
            //postSleeve();
        }

        $elem.find('.image-upload').imageuploader({
            callback: imageUploaded,
            csrftoken: settings.csrftoken
        });

        $elem.find('input').keydown(function () {
            enablePreview();
        });

        $elem.find('textarea').keydown(function () {
            enablePreview();
        });

        $elem.find('select').change(function() {
            enablePreview();
        });

        $elem.find('.cover-editor-preview > img').click(function(e) {
            $.imagemodal($(this).attr('src'));
        });

        function postSleeve(callback) {
            var values = {
                template: template_id,
                recordid: record_id,
                type: type,
                _token: settings.csrftoken
            };

            $elem.find('.cover-editor-preview-loader').show();

            $elem.find('input').each(function(i,v) {
                values[$(v).attr('name')] = $(v).val();
            });

            $elem.find('select').each(function(i,v) {
                values[$(v).attr('name')] = $(v).val();
            });
            console.log(values);

            $.post(settings.sleeve_api, values, function(data) {
                pollSleeve(data.id, callback);
            });
        }


        function pollSleeve(sleeve_id, callback) {
            $elem.find('.cover-editor-update').off('click');

            $.get(settings.sleeve_api + '/' + sleeve_id, function(data) {
                switch(data.status) {
                    case 'pending':
                        setTimeout(function() {
                            pollSleeve(sleeve_id, callback);
                        }, settings.poll_timeout);
                        break;
                    case 'complete':
                        setSleeve(data.file);
                        if(callback) callback();
                        break;
                }
            });
        }


        function imageUploaded() {
            enablePreview();
            $elem.find('.cover-editor-update').click();
        }


        function setSleeve(file) {
            $elem.find('.cover-editor-preview-loader').hide();
            var src = file;
            if(src.length > 0) {
                preview = src;
                $elem.find('.cover-editor-preview > img').attr('src', src);
            }
            enableFinish();
        }


        function enableFinish() {
            $('.cover-editor-finish').off('click').click(function(e) {
                e.preventDefault();
                finish();
            });
        }


        function enablePreview() {
            $('.cover-editor-finish').off('click').click(function(e) {
                e.preventDefault();
                postSleeve(finish);
            });
            $elem.find('.cover-editor-update').off('click').click(function(e) {
                e.preventDefault();
                postSleeve();
            });
        }


        function finish() {
            var values = {};

            values[type] = preview;

            $elem.find('input').each(function(i,v) {
                values[$(v).attr('name')] = $(v).val();
            });

            console.log(values);

            $.post(settings.save_url, values, function() {
                window.location = settings.next_step;
            });
        }
    };

}( jQuery ));